import * as React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors, sizes } from '../../styles';
import { IconButton } from '../../atoms/buttons';
import { withClickOutside } from '../../utils/click-outside';
import { smallScreenHeight } from './constants';

export interface Props {
  toggle: any;
  children?: any;
  drawerAlign: 'top' | 'bottom';
  className?: string;
}

export interface State {
  isOpened: boolean;
}

class NavDrawer extends React.Component<Props, State> {
  private drawerEl = null;

  constructor(props: Props) {
    super(props);
    this.state = { isOpened: false };
  }

  public handleToggle = () => {
    this.setState({
      isOpened: !this.state.isOpened,
    });
  };

  public onKeyPress = event => {
    if (event.keyCode === 27) {
      this.setState({
        isOpened: false,
      });
    }
  };

  public componentDidMount() {
    window.addEventListener('keydown', this.onKeyPress, true);
  }

  public componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyPress, true);
  }

  public handleClickOutside = e => {
    // make sure we're not clicking inside the abs positioned div
    if (!this.drawerEl || this.drawerEl.contains(e.target)) {
      return;
    }
    this.setState({
      isOpened: false,
    });
  };

  public render() {
    const { children, className, toggle, drawerAlign } = this.props;
    const { isOpened } = this.state;

    return (
      <div className={`${className}`}>
        {isOpened && (
          <div
            ref={el => (this.drawerEl = el)}
            className={`nav-drawer-content ${drawerAlign}`}
          >
            {React.Children.map(children, child =>
              React.cloneElement(child as any, {
                handleToggle: this.handleToggle,
              }),
            )}
          </div>
        )}
        <div className="nav-drawer-toggle" onClick={this.handleToggle}>
          {toggle}
        </div>
        {isOpened && <div className="screen" />}
      </div>
    );
  }
}

const WrappedNavDrawer = withClickOutside(NavDrawer);
const toggleWidth = '4rem';
const smallToggleHeight = '2.75rem';

export default styled(WrappedNavDrawer)`
  position: relative;

  .nav-drawer-toggle {
    cursor: pointer;
    width: ${toggleWidth};
    height: ${toggleWidth};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :hover .label {
    opacity: 1;
  }
  .nav-drawer-content {
    z-index: 4;
    position: absolute;
    min-width: 20rem;
    background: white;
    border-radius: 6px;
    left: ${toggleWidth};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    min-height: 8rem;
    :before {
      content: '';
      border-style: solid;
      border-width: 0.375rem 0.375rem 0.375rem 0;
      border-color: transparent ${colors.white} transparent transparent;
      position: absolute;
      left: -0.375rem;
    }
    &.top {
      top: 0;
      :before {
        top: 1.5rem;
      }
    }
    &.bottom {
      bottom: 0;
      :before {
        bottom: 1.5rem;
      }
    }
  }
  .screen {
    position: fixed;
    left: ${toggleWidth};
    right: 0;
    top: 0;
    bottom: 0;
    background: ${colors.screen};
    z-index: 2;
  }
  @media screen and (max-height: ${smallScreenHeight}) {
    .nav-drawer-toggle {
      height: ${smallToggleHeight};
    }
    .nav-drawer-content {
      &.top {
        :before {
          top: 1rem;
        }
      }
      &.bottom {
        :before {
          bottom: 1rem;
        }
      }
    }
  }
`;
